import {FC} from 'react';
import {Box} from '@chakra-ui/react';

export const EmptyValue: FC = () => (
  <Box color={'{colors.textTertiary}'} opacity={0.6}>
    —
  </Box>
);
